import { createSelector } from 'reselect';

// Config
import { CHANNEL_ISLANDS_POSTCODE_PREFIXES } from '@constants/postcodeConstants';
import { getSelectedCollectionPointPostcodeSelector } from '@redux/reducers/click-and-collect/clickAndCollectSelector';
import {
  getConfirmedDeliveryAddressPostcodeSelector,
  getSelectedDeliveryChoiceIdSelector,
} from '@redux/reducers/delivery/deliverySelector';
import { isClickAndCollectChoice, isDeliveryChoice } from '@utils/delivery/deliveryHelper';

const vatRefundMessageState = createSelector(
  [
    getSelectedDeliveryChoiceIdSelector,
    getConfirmedDeliveryAddressPostcodeSelector,
    getSelectedCollectionPointPostcodeSelector,
  ],
  (selectedDeliveryChoiceId, deliveryPostcode = '', clickAndCollectPostcode = '') => {
    const isDelivery = isDeliveryChoice(selectedDeliveryChoiceId);
    const isClickAndCollect = isClickAndCollectChoice(selectedDeliveryChoiceId);

    let postcode = '';
    if (isDelivery) {
      postcode = deliveryPostcode;
    } else if (isClickAndCollect) {
      postcode = clickAndCollectPostcode;
    }

    if (postcode) {
      return CHANNEL_ISLANDS_POSTCODE_PREFIXES.some((prefix) => postcode.startsWith(prefix));
    }

    return false;
  },
);

export default vatRefundMessageState;
